export default {
  env: "prod",
  api_url: "https://shield.getm2m.com/api/assettracker",
  app_cookie_name: "pulsewrx-asset-tracking-prod",
  session_cookie_name: "pulsewrx-asset-tracking-session-prod",
  gql_url: "https://8ui41jko40.execute-api.us-east-2.amazonaws.com/dev/graphql",
};
